import React, { useEffect, useState } from 'react';

// Authenticated SVG preview (fetched as blob, rendered in <img> so the SVG can't run scripts).
export const SvgPreview = ({ api, url, method = 'get', body, className = '', testId = 'svg-preview', refreshKey }) => {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    let alive = true; let obj;
    setErr(null);
    const req = method === 'post' ? api().post(url, body || {}, { responseType: 'blob' }) : api().get(url, { responseType: 'blob' });
    req.then(r => { if (!alive) return; obj = URL.createObjectURL(new Blob([r.data], { type: 'image/svg+xml' })); setSrc(obj); })
      .catch(() => alive && setErr('Preview unavailable'));
    return () => { alive = false; if (obj) URL.revokeObjectURL(obj); };
  }, [url, refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps
  if (err) return <div className="text-xs text-red-600 p-4" data-testid={`${testId}-error`}>{err}</div>;
  if (!src) return <div className="text-xs text-slate-400 p-4">Rendering…</div>;
  return <img src={src} alt="Faceplate preview" className={`max-w-full bg-white border border-slate-200 rounded-sm ${className}`} data-testid={testId} />;
};

export default SvgPreview;
